// ----------------------------------------------------------------------
// <copyright file="Izenda.Localizer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var ensure = require('ensure');
  var config = require('Izenda.Config');

  const { get, getOr } = require('lodash/fp');

  function Localizer() {
    this.activeLanguage = config.DefaultLanguage;
    this.languages = {};
  }

  /**
   * Register language data
   * @param {Array} array of localization keys
   * @param {String} language
   */
  Localizer.prototype.registerLanguage = function(data, language) {
    ensure(data, 'Invalid data');
    ensure(language, 'Language must be set');

    this.languages[language] = data;
  };

  /**
   * Set active language
   * @param {String} language
   */
  Localizer.prototype.setActiveLanguage = function(language) {
    ensure(language, 'Language is not valid');

    var isLanguageSupported = !!get(this.activeLanguage, this.languages);

    if (isLanguageSupported) {
      this.activeLanguage = language;
    }
  };

  /**
   * Get localization text in active language
   * @param {type} language
   */
  Localizer.prototype.getText = function(key, language=this.activeLanguage) {
    var activeLanguage = get(language, this.languages);

    return getOr('', key, activeLanguage);
  };

 /**
   * Get default Language
   */
  Localizer.prototype.getDefaultLanguage = function () {
    return config.DefaultLanguage;
  };

  var singleton = new Localizer();

  module.exports = singleton;
})();



// WEBPACK FOOTER //
// ./ui/share/localization/Izenda.Localizer.js